import { faApple } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { Build } from '~/components/organisms/Build';

export type IAppIosBuildPageProps = {
  appId: string;
};

export const AppIosBuildPage: React.FC<IAppIosBuildPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppIosBuildPage.seo.title')}</title>
      </Helmet>

      <Heading
        title={t('AppIosBuildPage.title')}
        subtitle={t('AppIosBuildPage.subtitle')}
        icon={<FontAwesomeIcon icon={faApple} />}
      />

      <Build appId={appId} platform="ios" />
    </>
  );
};
